var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.91115 9.67197L12.2844 16.7922L19.4046 9.41898C19.4286 9.39415 19.4545 9.37234 19.482 9.35355C19.6737 9.22205 19.9378 9.23879 20.1116 9.40664C20.3103 9.59846 20.3158 9.915 20.1239 10.1136L12.6564 17.8465C12.5643 17.9419 12.4381 17.9968 12.3055 17.9992C12.1729 18.0015 12.0448 17.951 11.9494 17.8588L4.2165 10.3913C4.04424 10.225 4.0172 9.96482 4.13816 9.76912C4.15668 9.73915 4.17867 9.71069 4.20416 9.68431C4.22813 9.65948 4.25406 9.63766 4.28146 9.61888C4.34766 9.5735 4.42245 9.54577 4.49918 9.53582C4.51774 9.5334 4.53641 9.53204 4.5551 9.53171C4.68304 9.52948 4.81183 9.57606 4.91115 9.67197Z","fill":"#121212"}));
}

CaretDown.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
